import { Key } from "@mui/icons-material";
import {
  CUSTOM_DATA_POINT_TYPE,
  CUSTOM_DATA_TYPE,
  SUPER_ADMIN_ROLE,
} from "../../app/Constants/Constants";

export const getCustomDataObj = (data) => ({
  dataPointId: data.id,
  type: data.type,
  name: data.messageName,
  collectorType: data.collectorType,
  fieldType: data.fieldType,
  definition: data.definition,
  piiHandling: data.piiHandling,
  customerCode: data.customerCode,
  collectorConfigId: data.collectorConfigId,
  status: data.status,
});

export const getCustomParam = /* istanbul ignore next */ (data) => ({
  companyId: data.companyId,
  collectorConfig: data.collectorConfig === "" ? null : data.collectorConfig,
  collectorType: data.collectorType === "" ? null : data.collectorType,
  customItemType: data.customItemType === "" ? null : data.customItemType,
  states: data.states === "" ? null : data.states,
  status: data.status === "" ? null : data.status,
});
export const fetchSourceCollectorList = (collectors) => {
  const list = collectors?.map((collector) => ({
    collectorConfiguration: {
      value: collector?.collectorConfigName,
    },
    collector: {
      value: collector?.collectorName,
    },
    lastObserved: {
      value: collector?.lastObservedOn,
    },
  }));
  return list?.sort((a, b) =>
    a?.collectorConfiguration?.value?.localeCompare(
      b?.collectorConfiguration?.value,
    ),
  );
};
export const fetchMappedKeyList = (mappedKeys) => {
  const list = mappedKeys?.map((mappedKey) => ({
    key: {
      value: mappedKey?.key,
    },
    customDatapointId: {
      value: mappedKey?.customDatapointId,
    },
    collector: {
      value: mappedKey?.collectorConfigName,
    },
    scope: {
      value: mappedKey?.scope,
    },
    lastObserved: {
      value: mappedKey?.lastObservedOn,
    },
    supported: {
      value: "No",
    },
  }));
  return list?.sort((a, b) =>
    a?.collector?.value?.localeCompare(b?.collector?.value),
  );
};

export const filterBoxData = /* istanbul ignore next */ (
  applicationCollector,
  collectorConfigList,
  allCompany,
  defaultCompany,
  auth,
  popUp,
) => {
  let role = auth?.user?.roleName === SUPER_ADMIN_ROLE;
  const DPList = [];
  if (!popUp) {
    DPList.push(
      {
        name: "Alias / Unmapped Key",
        DPValue: CUSTOM_DATA_TYPE.sort().map(
          /* istanbul ignore next */ (type) => {
            return {
              id: Math.random().toString(36).slice(2, 7),
              name: type,
              value: type,
              type: "type",
            };
          },
        ),
      },
      {
        name: "Data Point Type",
        DPValue: CUSTOM_DATA_POINT_TYPE.sort().map(
          /* istanbul ignore next */ (type) => {
            return {
              id: Math.random().toString(36).slice(2, 7),
              name: type,
              value: type,
              type: "dataPointType",
            };
          },
        ),
      },
    );
  }
  DPList.push(
    {
      name: "Collector",
      DPValue: applicationCollector?.sort()?.map(
        /* istanbul ignore next */ (collector) => {
          return {
            id: Math.random().toString(36).slice(2, 7),
            name: collector?.collectorDescription,
            value: collector?.id,
            type: "collectors",
          };
        },
      ),
    },
    {
      name: "Collector Configuration",
      DPValue: collectorConfigList?.sort()?.map(
        /* istanbul ignore next */ (collectorConfig) => {
          return {
            id: collectorConfig?.config?.value,
            name: collectorConfig?.name?.value,
            value: collectorConfig?.config?.value,
            type: "collectorConfigs",
          };
        },
      ),
    },
  );
  if (role && defaultCompany === null) {
    DPList.push({
      name: "Customer",
      DPValue: allCompany?.sort()?.map(
        /* istanbul ignore next */ (com) => {
          return {
            id: com?.companyuuid,
            name: com?.company_name,
            value: com?.companyuuid,
            type: "customers",
          };
        },
      ),
    });
  }
  return {
    DPList,
  };
};

export const filterApiData = /* istanbul ignore next */ (filterData) => {
  let type = "";
  let dataPointType = "";
  let collectors = [];
  let collectorConfigs = [];
  let customers = [];

  let typeCount = 0;
  let dataPointTypeCount = 0;

  filterData.forEach((data) => {
    switch (data.type) {
      case "type":
        typeCount++;
        if (typeCount === 1) {
          type = data.value;
        }
        break;
      case "dataPointType":
        dataPointTypeCount++;
        if (dataPointTypeCount === 1) {
          dataPointType = data.value;
        }
        break;
      case "collectors":
        collectors.push(data.value);
        break;
      case "collectorConfigs":
        collectorConfigs.push(data.value);
        break;
      case "customers":
        customers.push(data.value);
        break;
      default:
        break;
    }
  });

  const result = {
    collectors,
    collectorConfigs,
    customers,
  };

  if (typeCount === 1) {
    result.type = type;
  }

  if (dataPointTypeCount === 1) {
    result.dataPointType = dataPointType;
  }

  return result;
};
export const customFilterData = (data) => {
  return {
    id: data?.config?.value,
    name: data?.name?.value,
    value: data?.config?.value,
    type: "collectorConfigs",
  };
};
export const convertSourceToMappedKeyList = (mappedKeys, name) => {
  let defaultScope =
    process.env.REACT_APP_ON_DEMAND_CDM === "true"
      ? "Instrumented"
      : "Element Query";
  const list = mappedKeys?.map((mappedKey) => ({
    key: {
      value: name,
    },
    customDatapointId: {
      value: mappedKey?.customDatapointId,
    },
    collector: {
      value: mappedKey?.collectorConfigName,
    },
    scope: {
      value: mappedKey?.scope || defaultScope,
    },
    lastObserved: {
      value: mappedKey?.lastObservedOn,
    },
    supported: {
      value: "No",
    },
  }));
  return list?.sort((a, b) =>
    a?.collector?.value?.localeCompare(b?.collector?.value),
  );
};

export const convertConfigToMappedKeyList = (
  item,
  key,
  existingMappedKeys = [],
) => {
  if (!item) return [];
  const newConfigId = item?.config?.value;
  const newKey = key;
  const isDuplicate = existingMappedKeys.some(
    (existing) =>
      existing?.configId?.value === newConfigId &&
      existing?.key?.value === newKey,
  );
  if (isDuplicate) {
    return [];
  }
  const mappedKey = {
    key: {
      value: key,
    },
    configId: {
      value: item?.config?.value,
    },
    collector: {
      value: item?.name?.value,
    },
    scope: {
      value: "Instrumented",
    },
    lastObserved: {
      value: "Never",
    },
    supported: {
      value: "No",
    },
    newKeyFlag: {
      value: true,
    },
  };
  return [mappedKey];
};

export const groupByTypeFilter = (input) => {
  return input?.reduce((acc, item) => {
    if (!acc[item?.type]) {
      acc[item?.type] = [];
    }
    acc[item?.type].push(item?.value);
    return acc;
  }, {});
};

export const filterCustomDataDetails = (data) => {
  if (!data || !data.aliasId) return data;

  const {
    aliasId,
    type,
    displayName,
    definition,
    fieldType,
    mappedKeys,
    masterKey,
    messageName,
    stringType,
    enumeratedValues,
    unit,
    numberType,
    decimalPlaces,
    scaleMin,
    scaleMax,
  } = data;

  const result = {
    aliasId,
    type,
    definition,
    displayName,
    fieldType,
    mappedKeys,
    masterKey,
    messageName,
  };

  if (fieldType === "string" || fieldType === "array of string") {
    result.stringType = stringType;
    result.enumeratedValues =
      Array.isArray(enumeratedValues) &&
      enumeratedValues.length === 1 &&
      enumeratedValues[0] === ""
        ? []
        : enumeratedValues;
  } else if (fieldType === "number") {
    result.unit = unit;
    result.numberType = numberType;
    result.decimalPlaces = decimalPlaces;
    result.scaleMin = scaleMin;
    result.scaleMax = scaleMax;
  }

  return result;
};

export const aliasChangeTblLog = [
  {
    key: "Field",
    label: "Field",
  },
  {
    key: "Previous_Value",
    label: "Previous Value",
  },
  {
    key: "Empty_Value",
    label: "",
  },
  {
    key: "New_Value",
    label: "New Value",
  },
];

export const hasAlias = (list) => list?.some((item) => item?.alias === true);

export const getEventAliasItems = (arr) => {
  return arr
    ?.filter((item) => item?.alias)
    ?.map((item) => ({
      label: item?.displayName,
      value: item?.aliasId,
    }));
};
